import React from 'react'

import cx from 'classnames'
import Image from 'next/image'

import AmericanExpress from '../../assets/images/payment-methods/american-express.png'
import DinersClub from '../../assets/images/payment-methods/diners-club.png'
import Discover from '../../assets/images/payment-methods/discover.png'
import JCB from '../../assets/images/payment-methods/jcb.png'
import Mada from '../../assets/images/payment-methods/mada.png'
import Maestro from '../../assets/images/payment-methods/maestro.png'
import Mastercard from '../../assets/images/payment-methods/mastercard.png'
import UnionPay from '../../assets/images/payment-methods/union-pay.png'
import Visa from '../../assets/images/payment-methods/visa.png'

import styles from './PaymentMethodImage.module.scss'

type Props = {
  brand: string
  className?: string
}

export function PaymentMethodImage(props: Props) {
  const className = cx(styles.Image, props.className)
  switch (props.brand) {
    case 'amex':
    case 'american_express':
      return <Image className={className} src={AmericanExpress} alt="American Express" />
    case 'diners_club':
      return <Image className={className} src={DinersClub} alt="Diners Club" />
    case 'discover':
      return <Image className={className} src={Discover} alt="Discover" />
    case 'jcb':
      return <Image className={className} src={JCB} alt="JCB" />
    case 'mada':
      return <Image className={className} src={Mada} alt="Mada" />
    case 'mc':
    case 'mastercard':
      return <Image className={className} src={Mastercard} alt="Mastercard" />
    case 'maestro':
      return <Image className={className} src={Maestro} alt="Maestro" />
    case 'union_pay':
      return <Image className={className} src={UnionPay} alt="Union Pay" />
    case 'visa':
      return <Image className={className} src={Visa} alt="Visa" />
    default:
      return null
  }
}
